import { useReducer } from 'react';

export const useForceReRender = () => {
  const [, forceReRender] = useReducer((x) => x + 1, 0);
  return forceReRender;
};
